class OEEvents {
}
/**
 * 渲染事件
 */
OEEvents.RENDER = 'RENDER';
/**
 * 加载中
 */
OEEvents.LOAD_PROGRESS = 'LOAD_PROGRESS';
/**
 * 加载完成
 */
OEEvents.LOAD_COMPLETE = 'LOAD_COMPLETE';
/**
 * 加载出错
 */
OEEvents.LOAD_ERROR = 'LOAD_ERROR';
/**     * 模型选中     */
OEEvents.MESH_SELECT = 'MESH_SELECT';
/**     * 屏幕选中     */
OEEvents.VIEW_SELECT = 'VIEW_SELECT';
/**     * 标记选中     */
OEEvents.MARKER_SELECT = 'MARKER_SELECT';
/**     * 选中     */
OEEvents.SELECT = 'OE_SELECT';
/**     * 关闭     */
OEEvents.CLOSE = "OE_CLOSE";
/**     * 隐藏     */
OEEvents.HIDE = "OE_HIDE";
/**     * 显示     */
OEEvents.SHOW = "OE_SHOW";
/**     * 销毁     */
OEEvents.DISPOSE = "OE_DISPOSE";
/**     * 场景创建     */
OEEvents.SCENE_CREATED = "SCENE_CREATED";
/**     * 场景创建完成     */
OEEvents.SCENE_MOUNTED = "SCENE_MOUNTED";
/**     * 场景销毁     */
OEEvents.SCENE_DISPOSE = "SCENE_DISPOSE";
/**     * 场景销毁     */
OEEvents.LANGUAGE_CHANGE = "LANGUAGE_CHANGE";
/**
 * 创建加载进度
 * @param total_
 * @param loaded_
 * @param url_
 * @param name_
 * @param target_
 */
function createProgressEvent(total_, loaded_, url_, name_, target_) {
    return {
        total: total_,
        loaded: loaded_,
        url: url_,
        name: name_,
        loadRatio: Math.floor((loaded_ / total_) * 100),
        target: target_
    };
}
/**
 * 获取事件对象
 * @param e_
 */
function getOEProEvent(e_) {
    return e_.event;
}
/**
 * 根据原生事件创建 在线展馆事件
 * @param event_
 */
function createProgressEventByOri(event_, name_, target_) {
    if (!event_)
        return null;
    let xhr_ = event.currentTarget;
    if (!xhr_)
        return null;
    return {
        total: event_.total,
        loaded: event_.loaded,
        loadRatio: Math.floor((event_.loaded / event_.total) * 100),
        url: xhr_.responseURL,
        name: name_,
        target: target_
    };
}
export { OEEvents, createProgressEvent, createProgressEventByOri, getOEProEvent };
//# sourceMappingURL=OEEvents.js.map


// WEBPACK FOOTER //
// ./src/ts/core/OEEvents.js